import { useQuery } from '@tanstack/react-query';
import oaiApiClient from '../clients/oai-api/oai-api-client';
import { queryClient } from '../query-client';

const options = {
  queryFn: async () => {
    return oaiApiClient.info();
  },
  queryKey: ['user-info'],
};

export const useUserInfo = () => {
  return useQuery({
    queryKey: options.queryKey,
    queryFn: () => options.queryFn(),
    staleTime: 60 * 1000,
  });
};

export const ensureUserInfo = async () => {
  return await queryClient.ensureQueryData({
    queryKey: options.queryKey,
    queryFn: () => options.queryFn(),
  });
};

export const prefetchUserInfo = async () => {
  return await queryClient.prefetchQuery({
    queryKey: options.queryKey,
    queryFn: () => options.queryFn(),
  });
};
